"use client";
import PropTypes from "prop-types";

import Showcase from "components/company-detail/showcase";
import Campaigns from "@/src/components/company-detail/campaigns";
import CompanyInfo from "@/src/components/company-detail/company-info";
import Projects from "@/src/components/company-detail/projects";
import CompanyDetailMoreContent from "@/src/components/company-detail/more-content";
import Container from "@/src/components/grid/container";
import CompanyDetailContanctForm from "src/components/company-detail/contact-form";

import styles from "./style.module.css";

const CompanyDetailScreen = ({ pageResponse }) => {
  const isCampaign = pageResponse?.detailData?.[0]?.company?.companyCampaigns?.filter(
    (campaign) => campaign.date !== null
  )?.length;
  const companyData = pageResponse?.detailData?.[0]?.company;
  return (
    <>
      <div id="content-wrapper">
        <Showcase data={pageResponse} />
        <Container>
          <div className={styles.companyDetailWrapper}>
            <div>
              <CompanyDetailMoreContent introText={companyData?.introText} />
              {isCampaign ? <Campaigns data={pageResponse} /> : null}
              <Projects data={pageResponse} />
              <CompanyInfo data={pageResponse} />
            </div>
            <div className={styles.contactFormWrapper}>
              <CompanyDetailContanctForm companyData={companyData} />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};
CompanyDetailScreen.propTypes = {
  pageResponse: PropTypes.object,
};
export default CompanyDetailScreen;
